import Image from 'next/image';
import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const AquariusSwapsTriggerDetails = ({ trigger, triggerType }: Props) => {
  const poolAddress = useMemo(() => trigger.context?.pool_address ?? '', [trigger.context]);

  const poolUrl = useMemo(() => {
    if (!poolAddress) return '';
    return `https://stellar.expert/explorer/public/contract/${poolAddress}`;
  }, [poolAddress]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Pool"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/stellar.webp" width={12} height={12} alt="Stellar" />
            <span>{maskAddressValue(poolAddress) ?? ''}</span>
          </div>
        }
        href={poolUrl}
      />
    </div>
  );
};
